import { ChartTileComponent } from '../../dashboards/components/tiles/charts/chart-tile/chart-tile.component';
import { CustomComponentTile } from '../../dashboards/components/tiles/custom-component/custom-component-tile.component';
import { UserCustomComponentTile } from '../../dashboards/components/tiles/custom-component/user-custom-component-tile.component';
import { FiltersTileComponent } from '../../dashboards/components/tiles/filters/filters-tile.component';
import { ItemLookupTileComponent } from '../../dashboards/components/tiles/item-lookup-tile/item-lookup-tile.component';
import { LinkBannerTileComponent } from '../../dashboards/components/tiles/links/link-banner-tile/link-banner-tile.component';
import { ContactsTileComponent } from '../../dashboards/components/tiles/public/contacts-tile/contacts-tile.component';
import { FreeTrialTileComponent } from '../../dashboards/components/tiles/public/free-trial-tile/free-trial-tile.component';
import { HeroBannerV3TileComponent } from '../../dashboards/components/tiles/public/hero-banner-v3-tile/hero-banner-v3-tile.component';
import { IconColumnsTileComponent } from '../../dashboards/components/tiles/public/icon-columns-tile/icon-columns-tile.component';
import { PresentationTileComponent } from '../../dashboards/components/tiles/public/presentation-tile/presentation-tile.component';
import { RichTextTileComponent } from '../../dashboards/components/tiles/public/rich-text.component';
import { TextColumnsTileComponent } from '../../dashboards/components/tiles/public/text-columns-tile/text-columns-tile.component';
import { TextRowsTileComponent } from '../../dashboards/components/tiles/public/text-rows-tile/text-rows-tile.component';
import { TableTileComponent } from '../../dashboards/components/tiles/tables/table-tile/table-tile.component';
import { ChartSetupWizardComponent } from '../components/chart-setup-wizard/chart-setup-wizard.component';
import { ContactsSetupWizardComponent } from '../components/contacts-setup-wizard/contacts-setup-wizard.component';
import { AnalyticsHeatmapCustomComponentSetupWizardComponent } from '../components/custom-component-setup-wizard/analytics-heatmap-custom-component-setup-wizard.component';
import { DemoCountCustomComponentSetupWizardComponent } from '../components/custom-component-setup-wizard/demo-count-custom-component-setup-wizard.component';
import { DemoListCustomComponentSetupWizardComponent } from '../components/custom-component-setup-wizard/demo-list-custom-component-setup-wizard.component';
import { TenderListTileSetupWizardComponent } from '../components/custom-component-setup-wizard/tender-list-tile-setup-wizard.component';
import { UserCustomComponentSetupWizardComponent } from '../components/custom-component-setup-wizard/user-custom-component-setup-wizard.component';
import { FreeTrialSetupWizardComponent } from '../components/free-trial-setup-wizard/free-trial-setup-wizard.component';
import { FiltersSetupWizardComponent } from '../components/filters-setup-wizard/filters-setup-wizard.component';
import { HeroBannerV3SetupWizardComponent } from '../components/hero-banner-v3-setup-wizard/hero-banner-v3-setup-wizard.component';
import { IconColumnsSetupWizardComponent } from '../components/icon-columns-setup-wizard/icon-columns-setup-wizard.component';
import { ItemLookupSetupWizardComponent } from '../components/item-lookup-setup-wizard/item-lookup-setup-wizard.component';
import { LinkBannerSetupWizardComponent } from '../components/link-banner-setup-wizard/link-banner-setup-wizard.component';
import { PresentationSetupWizardComponent } from '../components/presentation-setup-wizard/presentation-setup-wizard.component';
import { TableSetupWizardComponent } from '../components/table-setup-wizard/table-setup-wizard.component';
import { TextColumnsSetupWizardComponent } from '../components/text-columns-setup-wizard/text-columns-setup-wizard.component';
import { TextRowsSetupWizardComponent } from '../components/text-rows-setup-wizard/text-rows-setup-wizard.component';
import { DynamicTileWidget } from '../components/widgets/dynamic.component';
import { ITileType } from '../interfaces/tile-type.interface';

export const TILE_TYPES: ITileType[] = [
  {
    key: 'rich-text',
    name: 'Rich text',
    setupWizard: DynamicTileWidget,
    component: RichTextTileComponent,
  },
  {
    key: 'link-banner-b',
    name: 'Link banner B',
    setupWizard: DynamicTileWidget,
    component: RichTextTileComponent,
  },
  {
    key: 'chart',
    name: 'Chart',
    setupWizard: ChartSetupWizardComponent,
    component: ChartTileComponent,
  },
  {
    key: 'table',
    name: 'Table',
    setupWizard: TableSetupWizardComponent,
    component: TableTileComponent,
  },
  {
    key: 'filters',
    name: 'Filters',
    setupWizard: FiltersSetupWizardComponent,
    component: FiltersTileComponent,
  },
  {
    key: 'item-lookup',
    name: 'Item Lookup',
    setupWizard: ItemLookupSetupWizardComponent,
    component: ItemLookupTileComponent,
  },
  // {
  //   key: 'map',
  //   name: 'Map',
  //   setupWizard: MapSetupWizardComponent,
  // },
  // TODO: Resolve later. It was disabled to start working... @shelepen-victor
  // {
  //   key: 'banner',
  //   name: 'Banner',
  //   setupWizard: BannerSetupWizardComponent,
  //   component: BannerTileComponent,
  // },
  {
    key: 'link-banner',
    name: 'Link Banner',
    setupWizard: LinkBannerSetupWizardComponent,
    component: LinkBannerTileComponent,
  },
  // {
  //   key: 'hero-banner',
  //   name: 'Hero Banner (Legacy)',
  //   setupWizard: HeroBannerSetupWizardComponent,
  // },
  {
    key: 'hero-banner-v3',
    name: 'Hero Banner V3',
    setupWizard: HeroBannerV3SetupWizardComponent,
    component: HeroBannerV3TileComponent,
  },
  {
    key: 'presentation',
    name: 'Presentation',
    setupWizard: PresentationSetupWizardComponent,
    component: PresentationTileComponent,
  },
  {
    key: 'contacts',
    name: 'Contacts',
    setupWizard: ContactsSetupWizardComponent,
    component: ContactsTileComponent,
  },
  {
    key: 'text-rows',
    name: 'Text Rows',
    setupWizard: TextRowsSetupWizardComponent,
    component: TextRowsTileComponent,
  },
  {
    key: 'text-columns',
    name: 'Text Columns',
    setupWizard: TextColumnsSetupWizardComponent,
    component: TextColumnsTileComponent,
  },
  {
    key: 'icon-columns',
    name: 'Icon Columns',
    setupWizard: IconColumnsSetupWizardComponent,
    component: IconColumnsTileComponent,
  },
  {
    key: 'free-trial',
    name: 'Free Trial',
    setupWizard: FreeTrialSetupWizardComponent,
    component: FreeTrialTileComponent,
  },
  {
    key: 'custom-component',
    name: 'Custom Component',
    setupWizard: UserCustomComponentSetupWizardComponent,
    component: UserCustomComponentTile,
  },
  {
    key: 'demo-count-custom-component',
    name: 'Count Custom Component',
    setupWizard: DemoCountCustomComponentSetupWizardComponent,
    component: UserCustomComponentTile,
  },
  {
    key: 'demo-list-custom-component',
    name: 'List Custom Component',
    setupWizard: DemoListCustomComponentSetupWizardComponent,
    component: UserCustomComponentTile,
  },
  {
    key: 'tender-list-tile',
    name: 'Tender List Tile',
    setupWizard: TenderListTileSetupWizardComponent,
    component: CustomComponentTile,
    previewInputs: {
      src: '/assets/tender-list-tile.mjs',
    },
  },
  {
    key: 'analytics-heatmap-custom-component',
    name: 'Analytics Heatmap Custom Component',
    setupWizard: AnalyticsHeatmapCustomComponentSetupWizardComponent,
    component: UserCustomComponentTile,
  },
];
